import { SIDEBAR_STATUS } from '@/constant/system/enums'
import Cookies from 'js-cookie'
import { defineStore } from 'pinia'

export const appStore = defineStore('app', {
  state: () => {
    return {
      sidebar: {
        // 是否折叠
        opened: Cookies.get('sidebarStatus') === SIDEBAR_STATUS.OPEN,
        withoutAnimation: false
      },
      device: 'desktop',
      size: Cookies.get('size') || 'medium'
    }
  },
  actions: {
    toggleSideBar() {
      this.sidebar.opened = !this.sidebar.opened
      this.sidebar.withoutAnimation = false
      if (this.sidebar.opened) {
        Cookies.set('sidebarStatus', SIDEBAR_STATUS.OPEN)
      } else {
        Cookies.set('sidebarStatus', SIDEBAR_STATUS.CLOSE)
      }
    },
    closeSideBar(withoutAnimation: boolean) {
      Cookies.set('sidebarStatus', SIDEBAR_STATUS.CLOSE)
      this.sidebar.opened = false
      this.sidebar.withoutAnimation = withoutAnimation
    },
    toggleDevice(device: string) {
      this.device = device
    },
    setSize(size: string) {
      this.size = size
      Cookies.set('size', size)
    }
  }
})
